import cn from 'clsx'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import Image from 'components/Common/Image'
import { LoyaltyLandingPageTileDetails } from '../LoyaltyLandingPageData'
import TextButton from 'components/Luxkit/Button/TextButton'
import Group from 'components/utils/Group'

const LargeTile = styled(Pane)`
  display: grid;
  grid-template-rows: ${rem(148)} 1fr;
  grid-template-areas:
  'image'
  'content';

  ${mediaQueryUp.tablet} {
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: 'image content';

    &.reverse {
      grid-template-areas: 'content image';
    }
  }
`

const LargeTileContent = styled(Group)`
  padding: ${rem(16)};
  grid-area: content;

  ${mediaQueryUp.tablet} {
    padding: ${rem(68)} ${rem(24)};
  }
`

const TileImageContainer = styled.div`
  position: relative;
  grid-area: image;
`

const TileImage = styled(Image)`
  position: absolute;
  left: 0;
  top: 0;
`

interface Props {
  tile: LoyaltyLandingPageTileDetails;
  /**
   * Reverses the order of the content (content first, image second)
   */
  reverse?: boolean;
  /**
   * Will show a button to activate free membership
   */
  onActivate?: () => void;
}

function LoyaltyLandingPageLargeTile(props: Props) {
  const { tile, reverse, onActivate } = props

  return <LargeTile className={cn({ reverse })}>
    <TileImageContainer>
      <TileImage image={tile.image} fit="center" dpr={2}/>
    </TileImageContainer>
    <LargeTileContent direction="vertical" gap={16} tabletGap={24}>
      <VerticalSpacer gap={12}>
        <Heading variant="heading3">{tile.title}</Heading>
        <BodyText variant="large">{tile.description}</BodyText>
      </VerticalSpacer>
      {!!onActivate && <TextButton kind="primary" onClick={onActivate}>
        Activate your free membership
      </TextButton>}
    </LargeTileContent>
  </LargeTile>
}

export default LoyaltyLandingPageLargeTile
